import { Component } from "react"
import PropTypes from "prop-types"
import { isFinite } from "lodash"
import { makeCustomFactorFormatter } from "helpers/formatters/numbers"
import { Paper, IconButton } from "@mui/material"
import { Close } from "@mui/icons-material"
import { EXPOSURE_CONSTRAINT_WEIGHTINGS } from "helpers/contentSetConstants"
import FactorConstraintInput from "components/factor-constraint-input"

class Factor extends Component {
  static propTypes = {
    factor: PropTypes.object.isRequired,
    removeFactor: PropTypes.func.isRequired,
    updateFactor: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {}

    if (isFinite(props.factor.min)) {
      this.state.minValue = props.factor.min
    } else {
      this.state.minValue = isFinite(props.factor.originalMin) ? props.factor.originalMin : ""
    }

    if (isFinite(props.factor.max)) {
      this.state.maxValue = props.factor.max
    } else {
      this.state.maxValue = isFinite(props.factor.originalMax) ? props.factor.originalMax : ""
    }
  }

  onRemoveFactor = () => {
    const { factor, removeFactor } = this.props
    removeFactor(factor)
  }

  onUpdateFactor = ({ id, value }) => {
    const { factor, updateFactor } = this.props
    const { minValue, maxValue } = this.state
    let min = null
    let max = null

    const newValue = value ? parseFloat(value) : ""

    if (id === "min") {
      min = newValue
      max = maxValue && parseFloat(maxValue)
    } else {
      max = newValue
      min = minValue && parseFloat(minValue)
    }

    const exposureWeighting = factor.isCurrency ? EXPOSURE_CONSTRAINT_WEIGHTINGS.CURRENCY : EXPOSURE_CONSTRAINT_WEIGHTINGS.PERCENT
    updateFactor(factor.id, factor.contentSetId, min, max, exposureWeighting)

    this.setState({ minValue: min, maxValue: max })
  }

  render() {
    const { factor } = this.props

    const placeholderSuffix = `${factor.isCurrency ? "Currency " : ""}Exposure`

    const formatter = makeCustomFactorFormatter(factor.isCurrency)

    return <Paper square>
      <div className="factor-form">
        <div className="factor-name-wrapper">
          <IconButton aria-label="Remove" onClick={this.onRemoveFactor} size="large">
            <Close fontSize="small" />
          </IconButton>
          <div className="factor-name">{factor.name}</div>
        </div>
        <div className="input-wrapper">
          <div className="input-wrapper-row">
            <div className="minimum">
              <div className="factor-input">
                <FactorConstraintInput {...{
                  id: "min",
                  autoFocus: true,
                  error: factor.error,
                  placeholder: `Min ${placeholderSuffix}`,
                  initialValue: this.props.factor.min,
                  onChange: this.onUpdateFactor,
                  supportMultiplierSuffix: factor.isCurrency,
                }}
                />
              </div>
            </div>
            <div className="maximum">
              <div className="factor-input">
                <FactorConstraintInput {...{
                  id: "max",
                  error: factor.error,
                  placeholder: `Max ${placeholderSuffix}`,
                  initialValue: this.props.factor.max,
                  onChange: this.onUpdateFactor,
                  supportMultiplierSuffix: factor.isCurrency,
                }}
                />
              </div>
            </div>
          </div>
          {factor.error && <div className="input-error">{factor.error}</div>}
        </div>
        <div className="z-score">{formatter(factor.zScore)}</div>
      </div>
    </Paper>
  }
}

export default Factor
